import React from 'react';
import t from 'prop-types';

var EntradaTipoGenerica = function EntradaTipoGenerica(_ref) {
  var titulo = _ref.titulo,
      clase = _ref.clase,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: clase,
    onClick: onClick
  }, titulo && React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  }));
};

EntradaTipoGenerica.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  clase: t.string,
  onClick: t.func
} : {};
export default EntradaTipoGenerica;